import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
import "./pagination.scss";
import { Link } from "react-router-dom";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className={classnames("page_navigation", { [className]: className })}>
      <li
        className={classnames("page-item", {
          disabled: currentPage === 1,
        })}
      >
        <Link
          className="page-link"
          onClick={onPrevious}
          disabled={currentPage === 1}
        >
          <span className="flaticon-left-arrow"></span> Prev
        </Link>
      </li>
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return (
            <li className="pagination-item dots" key={pageNumber}>
              &#8230;
            </li>
          );
        }

        return (
          <li
            key={pageNumber}
            className={classnames("page-item", {
              active: pageNumber === currentPage,
            })}
          >
            <Link
              className="page-link"
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </Link>
          </li>
        );
      })}
      <li
        className={classnames("page-item", {
          disabled: currentPage === lastPage,
        })}
      >
        <Link
          className="page-link"
          onClick={onNext}
          disabled={currentPage === lastPage}
        >
          <span className="flaticon-right-arrow"></span>
        </Link>
      </li>
    </ul>
  );
};

export default Pagination;
